import React from 'react'

const IconRenderer = (props) => {
    let iconType;
    switch (props?.data?.status) {
      case "Pending":
        iconType = "load";
        break;
      case "Done":
        iconType = "check";
        break;
      case "Recalled":
        iconType = "block";
        break;
      default:
        iconType = "none";
        break;
    }

    return (
      <div className="icon-list">
        <div className="icon-container-list">
          <viedoc-icon attribute="nocolor" name={iconType} />
        </div>
      </div>
    );
  };

  export default IconRenderer;